var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"质疑登记"}},[_c('questionRegister')],1),_c('TabPane',{attrs:{"label":"投诉登记"}},[_c('complaintRegister')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }